<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <!-- <banner :bgImage="bgImage"></banner> -->
    <div class="solutionCaseBanner">
        <div class="solutionCaseBannerIn">智慧医疗解决方案</div>
    </div>
<section class="solutionConcept">
	<div class="solutionCaseBox" style="padding-bottom:0;">
    	<div class="solutionConceptBox">
        	<div class="solutionConceptBoxR"><img src="../../../static/images/solutionConceptPic4.jpg"></div>
            <div class="solutionConceptBoxL">
            	<div class="solutionConceptIn">
                	<div class="solutionConceptInTit">项目概念</div>
                    <div class="solutionConceptInConn">通过区域综合信息平台的互联互通、资源共享，实现公共卫生、医疗服务和卫生管理的一体化。解决不同医院之间的医疗资料系统无法互通的问题。</div>
                </div>
                <div class="solutionConceptArr"></div>
            </div>
        </div>
    </div>
</section>
<section class="solutionIncome">
	<div class="solutionCaseBox">
    	<div class="solutionCaseTit">客户收益</div>
    	<ul class="solutionIncomeFlex">
        	<li>
            	<img src="../../../static/images/solutionDetailIcon09.png">
                <div class="solutionIncomeConn">通过医疗数据云平台<br />满足人们对医疗需求的多样性</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon10.png">
                <div class="solutionIncomeConn">缓和医疗资源<br />不足分布不匀的矛盾</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionDetailIcon07.png">
                <div class="solutionIncomeConn">打破医疗机构之间<br />的“信息孤岛”问题</div>
            </li>
        </ul>
    </div>
</section>
<section class="solutionAdvantage">
	<div class="solutionAdvantageBox">
    	<div class="solutionAdvantageTit">项目优势</div>
    	<img src="../../../static/images/solutionAdvantageIcon04.png">
        <div class="solutionAdvantageConn" style="left:220px; top:205px;">
        	<div class="solutionAdvantageConnTit bold">弹性带宽传输</div>
            <div class="solutionAdvantageConnBox center">IPv6为医疗大数据<br />分析提供保障</div>
        </div>
        <div class="solutionAdvantageConn" style="right:220px; top:205px;">
        	<div class="solutionAdvantageConnTit bold">提供足量IP地址</div>
            <div class="solutionAdvantageConnBox center">IPv6助力医疗卫生专网<br />及拓展互物网应用</div>
        </div>
        <div class="solutionAdvantageConn" style="left:480px; bottom:50px;">
        	<div class="solutionAdvantageConnTit bold">节约成本</div>
            <div class="solutionAdvantageConnBox center">集中部署，远程应用<br />节约医疗机构的运维成本</div>
        </div>
	</div>
</section>
<section class="solutionValue">
	<div class="solutionCaseBox">
    	<div class="solutionCaseTit">项目价值</div>
    	<ul class="solutionIncomeFlex">
        	<li>
            	<img src="../../../static/images/solutionValuePic01.png">
                <div class="solutionIncomeConn">各级疾病预防控制机构和卫生行政<br />部门可以同时在线报告信息</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionValuePic02.png">
                <div class="solutionIncomeConn">极大地提高了传染病疫情等报告的<br />及时性和准确性</div>
            </li>
            <li>
            	<img src="../../../static/images/solutionValuePic03.png">
                <div class="solutionIncomeConn">提高了突发公共卫生事件的应急反应<br />和危机处置能力</div>
            </li>
        </ul>
    </div>
</section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage: "../../../static/images/solutionCaseBanner2.jpg?011901",
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./solution";
.solutionCase {
    .solutionCaseBanner{
         background:url(../../../static/images/solutionCaseBanner2.jpg?011902) no-repeat center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/solution/solutionCase5.vue